// extracted by mini-css-extract-plugin
export default {"container":"ScrollContainer_container__MzA1O","imageContainer":"ScrollContainer_imageContainer__MGI1Z","image":"ScrollContainer_image__OGJhY"};